/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'

import { SlackIcon, SliteIcon } from '@slite/icons'

import type { Scenario } from './types'

const OUTDATED = `# Troubleshooting

Common issues and how to fix them.

{+## SSO: Google Workspace+}
{+If login fails, re-authenticate via Settings → Security →+}
{+Disconnect and reconnect Google Workspace. Most issues stem+}
{+from stale OAuth tokens after a workspace admin change.+}

## Can't log in
Make sure you're using the email address tied to your
Slite workspace. Reset your password from the login page
if needed.

## Docs not loading
Try a hard refresh (Cmd+Shift+R) or clear your browser
cache. If the issue persists, try a different browser.

## Search not returning results
Re-index your workspace from Settings → Advanced →
Reindex. Results update within a few minutes.

## Notifications not arriving
Check that notifications are enabled in Settings →
Notifications and that Slite isn't blocked by your
browser or OS.
`

const APPLIED = `# Troubleshooting

Common issues and how to fix them.

## SSO: Google Workspace
If login fails, re-authenticate via Settings → Security →
Disconnect and reconnect Google Workspace. Most issues stem
from stale OAuth tokens after a workspace admin change.

## Can't log in
Make sure you're using the email address tied to your
Slite workspace. Reset your password from the login page
if needed.

## Docs not loading
Try a hard refresh (Cmd+Shift+R) or clear your browser
cache. If the issue persists, try a different browser.

## Search not returning results
Re-index your workspace from Settings → Advanced →
Reindex. Results update within a few minutes.

## Notifications not arriving
Check that notifications are enabled in Settings →
Notifications and that Slite isn't blocked by your
browser or OS.
`

export const selfMaintainedScenario: Scenario = {
  id: 'self-maintained',
  buttonLabel: 'Self-maintaining doc',
  initialDocId: 'troubleshooting',
  signal: {
    icon: <SliteIcon size={16} />,
    label: 'This doc is due for self-maintenance',
  },
  routine: {
    label: 'Reviewing doc',
  },
  sourceSignal: {
    icon: <SlackIcon size={16} />,
    label: 'Workaround was reported in a #support',
  },
  finding: 'Doc is missing a new Google Workspace SSO workaround.',
  diff: {
    docId: 'troubleshooting',
    outdatedContent: OUTDATED,
    appliedContent: APPLIED,
    pill: { kind: 'add', text: 'SSO: Google Workspace section' },
  },
  routeNote: 'Suggested by the doc’s weekly self-maintenance review.',
  reviewer: { name: 'Maya', cursorColor: 'var(--saturn-orange)' },
}
